import { Form } from "@circle-react-uikit/Form";

interface PostPurchaseCustomButtonLabelInputTextProps {
  isDisabled: boolean;
}

export const PostPurchaseCustomButtonLabelInputText = ({
  isDisabled,
}: PostPurchaseCustomButtonLabelInputTextProps) => (
  <Form.Item
    className="!mt-0 !py-0"
    name="post_purchase_email_meta.button_label"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    fullWidth
    hideBorder
    hideDescription
  >
    <Form.Input disabled={isDisabled} />
  </Form.Item>
);
